import { DialogConfig } from '@angular/cdk/dialog';
import { ComponentType } from '@angular/cdk/portal';

export type OpenEvent = [ComponentType<unknown>, DialogConfig];
